'use client'

import { datadogRum } from '@datadog/browser-rum'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { normalizeRoute } from '@lib/normalizeRoute'

/**
 * Names each route change as its own RUM view. The RUM react plugin runs with
 * `router: false` (App Router isn't its supported router), so without this all
 * page metrics — Core Web Vitals, load time, error rate — collapse into one view.
 */
export const RumViewTracker = () => {
  const pathname = usePathname()

  useEffect(() => {
    if (!pathname || !datadogRum.getInitConfiguration()) return
    datadogRum.startView({ name: normalizeRoute(pathname) })
  }, [pathname])

  return null
}
